import React, { useEffect, useState, useCallback } from "react";
import { useParams, Link } from "react-router-dom";
import { supabase } from "../supabaseClient";
import jsPDF from "jspdf";
import QRCode from "qrcode";
import "./pages.css";

export default function EventPage() {
  const { id } = useParams();
  const [event, setEvent] = useState(null);
  const [currentUser, setCurrentUser] = useState(null);
  const [ setPaymentStarted] = useState(false); // fixed
  const [hasBooked, setHasBooked] = useState(false);
  const [ticket, setTicket] = useState(null);
const [loading, setLoading] = useState(true);
  const invoiceId = `INV-${crypto.randomUUID()}`;

 const [isAdmin, setIsAdmin] = useState(false);

// Fetch role
useEffect(() => {
  const fetchUser = async () => {
    const { data: { user } } = await supabase.auth.getUser();
    if (user) {
      setCurrentUser(user);

      const { data: profile } = await supabase
        .from('users')
        .select('role')
        .eq('id', user.id)
        .single();

      if (profile?.role === 'admin') setIsAdmin(true);
    }
  };
  fetchUser();
}, []);

  // Fetch current user
  useEffect(() => {
    const fetchUser = async () => {
      const { data: { user }, error } = await supabase.auth.getUser();
      if (user) setCurrentUser(user);
      else console.error("No user:", error?.message);
    };
    fetchUser();
  }, []);

  // Fetch event details
useEffect(() => {
  const fetchEvent = async () => {
    setLoading(true);
    const { data, error } = await supabase
      .from("events")
      .select("*")
      .eq("id", id)
      .single();
    if (error) console.error("Error fetching event:", error.message);
    else setEvent(data);
    setLoading(false);
  };
  fetchEvent();
}, [id]);


  // Check if the user already booked
  useEffect(() => {
    const checkIfBooked = async () => {
      if (!currentUser || !event) return;
      const { data: existingTicket } = await supabase
        .from("ticket_sales")
        .select("*")
        .eq("user_id", currentUser.id)
        .eq("event_id", event.id)
        .single();

      if (existingTicket) {
        setHasBooked(true);
        setTicket(existingTicket);
      }
    };
    checkIfBooked();
  }, [currentUser, event]);

  // Save ticket to database
  const handleTicketSave = useCallback(
    async (invoice) => {
      if (!currentUser || !event) return;

      const { data: existingTicket } = await supabase
        .from("ticket_sales")
        .select("*")
        .eq("user_id", currentUser.id)
        .eq("event_id", event.id)
        .single();

      if (!existingTicket) {
        await supabase.from("ticket_sales").insert([
          {
            user_id: currentUser.id,
            event_id: event.id,
            amount: event.price,
            invoice_id: invoice,
            status: "paid",
          },
        ]);
      }

      window.location.href = "/profile?section=events";
    },
    [currentUser, event]
  );

  // IntaSend payment listener
  useEffect(() => {
    if (!event || !currentUser) return;

    const intaSend = new window.IntaSend({
      publicAPIKey: "ISPubKey_test_a4d1a389-e6fc-411c-bf16-f4df56d23d6b",
      live: false,
    });

    intaSend
      .on("COMPLETE", async (results) => {
        await handleTicketSave(results.invoice_id || invoiceId);
      })
      .on("FAILED", (results) => console.log("Payment failed:", results))
      .on("IN-PROGRESS", (results) => console.log("Payment in progress:", results));
  }, [event, currentUser, handleTicketSave, invoiceId]); // fixed dependencies

  // Download PDF ticket
  const handleDownloadTicket = async () => {
    if (!ticket || !currentUser || !event) return;

    const doc = new jsPDF({ orientation: "landscape", unit: "mm", format: [210, 99] });
    doc.setDrawColor(0);
    doc.setLineWidth(1);
    doc.rect(10, 10, 190, 79);

    doc.setFontSize(20);
    doc.setFont("helvetica", "bold");
    doc.text(event.tittle.toUpperCase(), 20, 25);

    doc.setLineWidth(0.3);
    doc.setDrawColor(150);
    doc.line(20, 28, 190, 28);

    doc.setFontSize(12);
    doc.setFont("helvetica", "normal");
    doc.text("Date:", 20, 40);
    doc.text(event.date || "", 50, 40);
    doc.text("Location:", 20, 48);
    doc.text(event.location || "", 50, 48);
    doc.text("Attendee:", 20, 56);
    doc.text(currentUser.email || "", 50, 56);
    doc.text("Invoice ID:", 20, 64);
    doc.text(ticket.invoice_id || "—", 50, 64);
    doc.text("Amount Paid:", 20, 72);
    doc.text("Ksh " + event.price, 50, 72);

    doc.setLineWidth(0.1);
    doc.setDrawColor(100);
    doc.setLineDashPattern([1, 1], 0);
    doc.line(150, 10, 150, 89);

    const qrText = `ticket-${event.id}-${currentUser.id}-${ticket.invoice_id}`;
    try {
      const qrDataUrl = await QRCode.toDataURL(qrText);
      doc.addImage(qrDataUrl, "PNG", 155, 30, 40, 40);
    } catch (err) {
      console.error("Error generating QR code:", err);
    }

    doc.setFontSize(10);
    doc.setFont("helvetica", "italic");
    doc.text("Please present this ticket at the entrance.", 20, 85);

    doc.save(`${event.tittle}-ticket.pdf`);
  };

if (loading)
  return (
    <div className="full-screen-loader">
      <div className="loader-card">
        <div className="loader-dot"></div>
        <div className="loader-dot"></div>
        <div className="loader-dot"></div>
        <p className="loader-text">Loading Event...</p>
      </div>
    </div>
  );


  return (
    <div className="event-page-container">
      <div className="event-page-header">
        <img src={event.image_url} alt={event.tittle} className="event-page-image" />
      </div>

      <div className="event-page-content">
        <h1 className="event-page-title">{event.tittle}</h1>

        <div className="event-page-info">
          <p><strong>Date:</strong> {event.date}</p>
          <p><strong>Time:</strong> {event.time}</p>
          <p><strong>Location:</strong> {event.location}</p>
          <p><strong>Category:</strong> {event.category}</p>
          <p><strong>Price:</strong> Ksh. {event.price}</p>
        </div>

        <p className="event-page-description">{event.description}</p>

        {hasBooked ? (
  <div className="ticket-info-box">
    <p className="booked-message">✅ You’ve already booked this event.</p>
    <p><strong>Invoice ID:</strong> {ticket?.invoice_id}</p>
    <p><strong>Status:</strong> {ticket?.status || "Paid"}</p>
    <button onClick={handleDownloadTicket} className="btn download-btn">
      🎟️ Download Ticket
    </button>
  </div>
) : (
  <button
    className="intaSendPayButton pay-button"
    data-public-key="ISPubKey_test_a4d1a389-e6fc-411c-bf16-f4df56d23d6b"
    data-hosted-payment="true"
    data-amount={event.price}
    data-currency="KES"
    data-email={currentUser?.email || "demo@example.com"}
    onClick={async () => {
      if (isAdmin) {
        // Admin bypasses payment and books instantly
        await handleTicketSave(`ADMIN-${invoiceId}`);
      } else {
        setPaymentStarted(true); // normal users trigger IntaSend
      }
    }}
  >
    Book This Event
  </button>
)}

<Link to="/" className="back-link">
  ← Back to All Events
</Link>
      </div>
    </div>
  );
}
